<nav class="nav-sidebar" [class.mobile-open]="isMobileMenuOpen">
  <div class="nav-header">
    <h1>Me and My Planet</h1>
  </div>

  <div class="nav-content">
    <!-- Only show admin items if admin check is true -->
    @if (isGroupAdmin || isSuperAdmin) {
      <div class="separator"></div>
      <div class="nav-admin-items">
        <!-- Only show super admin item if super admin check is true -->
        @if (isSuperAdmin) {
          <a
            class="nav-item"
            routerLink="/group-admins"
            routerLinkActive="is-active"
            (click)="closeMobileMenu()"
            >
            <app-icon name="key"></app-icon>
            <span>Group Admins</span>
          </a>
        }
        <a
          class="nav-item"
          routerLink="/group"
          routerLinkActive="is-active"
          (click)="closeMobileMenu()"
          >
          <app-icon name="groups"></app-icon>
          <span>Groups</span>
        </a>
      </div>
    }

    @if (user) {
      <div class="separator"></div>
      <div class="nav-main-items">
        <a
          class="nav-item"
          routerLink="/dashboard"
          routerLinkActive="is-active"
          (click)="closeMobileMenu()"
          >
          <app-icon name="home"></app-icon>
          <span>Dashboard</span>
        </a>
        <a
          class="nav-item"
          routerLink="/logs/daily"
          routerLinkActive="is-active"
          (click)="closeMobileMenu()"
          >
          <app-icon name="calendar"></app-icon>
          <span>Daily Logs</span>
        </a>
        <a
          class="nav-item"
          routerLink="/logs/general"
          routerLinkActive="is-active"
          (click)="closeMobileMenu()"
          >
          <app-icon name="house_plugged"></app-icon>
          <span>General Emissions</span>
        </a>
        <a
          class="nav-item"
          routerLink="/report"
          routerLinkActive="is-active"
          (click)="closeMobileMenu()"
          >
          <app-icon name="chart_bar_column"></app-icon>
          <span>My Report</span>
        </a>
      </div>
    }

    <div class="separator"></div>

    <div class="nav-sub-items">
      <a
        class="nav-item"
        routerLink="/about"
        routerLinkActive="is-active"
        (click)="closeMobileMenu()"
        >
        <span>About this Project</span>
      </a>
      <a
        class="nav-item"
        routerLink="/faq"
        routerLinkActive="is-active"
        (click)="closeMobileMenu()"
        >
        <span>FAQ</span>
      </a>
      <a
        class="nav-item"
        routerLink="/contact"
        routerLinkActive="is-active"
        (click)="closeMobileMenu()"
        >
        <span>Contact</span>
      </a>
    </div>
  </div>

  @if (user) {
    <div class="nav-footer">
      <div class="user-info">
        <p id="name">
          {{ user.firstName }}
          {{ user.lastName }}
        </p>
        <p id="role">
          {{ getDisplayRole(user) }}
        </p>
      </div>
      <div class="footer-icons">
        <a
          class="action-icon settings"
          routerLink="/profile"
          (click)="closeMobileMenu()"
          >
          <app-icon name="settings" />
        </a>
        <a
          class="action-icon logout"
          (click)="logout()"
          (click)="closeMobileMenu()"
          >
          <app-icon name="logout" />
        </a>
      </div>
    </div>
  }
</nav>

<!-- Burger Menu -->
@if (isMobile) {
  <div class="burger-menu" (click)="toggleMobileMenu()">
    <app-icon name="menu" size="32px" color="white"></app-icon>
  </div>
}

@if (isMobile && isMobileMenuOpen) {
  <div
    class="overlay"
    (click)="toggleMobileMenu()"
  ></div>
}
